import constants.CompanyConstants.Companion.companyName
import constants.CompanyConstants.Companion.dropDownMenuEntriesProdukte
import constants.CompanyConstants.Companion.dropDownMenuEntriesUnternehmen
import constants.CompanyConstants.Companion.navigationElementStyleClass
import content.*
import kotlinReactComponents.companySlogan
import kotlinReactComponents.dropDownMenu
import kotlinReactComponents.navigationElement
import kotlinx.html.id
import react.Props
import react.RBuilder
import react.fc
import react.useState
import styled.*


external interface SetArticleProps : Props {
    var clickedEntry: String
}

class BaseLayout(
) {
    fun RBuilder.baseLayoutTable() {
        val (clickedEntry, setClickedEntry) = useState("")
        styledTable {
            attrs.id = "headerTable"
            css {
                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                +BaseLayoutStyles.baseBackgroundColor
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.stdtTableLayout
                +BaseLayoutStyles.alignContentAtEnd
                +BaseLayoutStyles.overflowHidden
                +BaseLayoutStyles.standardFont
//                +BaseLayoutStyles.dottedBorder1px
            }
            styledTbody {
                attrs.id = "headerTableBody"
                css {
                    +BaseLayoutStyles.noMarginNoPaddingNoBorders
                    +BaseLayoutStyles.top0px
//                    +BaseLayoutStyles.headerHeight
                }
                styledTr {
                    attrs.id = "headerTableRow"
                    css {
                        +BaseLayoutStyles.noMarginNoPaddingNoBorders
                        +BaseLayoutStyles.top0px
//                        +BaseLayoutStyles.headerHeight
                    }
                    styledTd {
                        attrs.id = "headerTd1"
                        css {
                            +BaseLayoutStyles.noMarginNoPaddingNoBorders
                            +BaseLayoutStyles.widthVwMinusSloganWidth
                            +BaseLayoutStyles.top0px
//                            +BaseLayoutStyles.headerHeight
                        }
                        styledHeader {
                            css {
                                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                                +BaseLayoutStyles.companyName
                                +BaseLayoutStyles.blackLetters
                                +BaseLayoutStyles.alignTextCenter
//                                +BaseLayoutStyles.headerHeight
                                +BaseLayoutStyles.top0px
                            }
                            +companyName.fullNameString()
                        }
                    }
                    //Company Slogan
                    styledTd {
                        attrs.id = "headerTd2"
                        css {
                            +BaseLayoutStyles.noMarginNoPaddingNoBorders
                            +BaseLayoutStyles.width8em
                            +BaseLayoutStyles.top0px
                            +BaseLayoutStyles.headerHeight
                        }
                        companySlogan()
                    }
                }
            }
        }

        styledTable {
            attrs.id = "navigationTable"
            css {
                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                +BaseLayoutStyles.baseBackgroundColor
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.stdtTableLayout
                +BaseLayoutStyles.alignContentAtEnd
                +BaseLayoutStyles.standardFont
//                +BaseLayoutStyles.dottedBorder1px
            }

            styledTbody {
                attrs.id = "navTableBody"
                css {
                    +BaseLayoutStyles.noMarginNoPaddingNoBorders
//                    +BaseLayoutStyles.solidBorder1px
                }
                //Navigation Bar
                styledTr {
                    attrs.id = "navRow"
                    css {
                        +BaseLayoutStyles.noMarginNoPaddingNoBorders
                        +BaseLayoutStyles.navigationBar
                        +BaseLayoutStyles.alignContentAtEnd
                        +BaseLayoutStyles.alignTextRight
                        +BaseLayoutStyles.top0px
//                        +BaseLayoutStyles.solidBorder1px
                    }

                    styledTd {
                        css {
                            +BaseLayoutStyles.widthVwMinusNavItemsWidth
                            +BaseLayoutStyles.alignContentAtEnd
                            +BaseLayoutStyles.alignTextRight
//                            +BaseLayoutStyles.solidBorder1px
                        }
                    }
                    styledTd {
                        css {
                            +BaseLayoutStyles.alignContentAtEnd
                            +BaseLayoutStyles.alignTextCenter
                            +BaseLayoutStyles.width6To9em
//                            +BaseLayoutStyles.solidBorder1px
                        }
                        dropDownMenu {
                            attrs {
                                this.title = dropDownMenuEntriesProdukte.title
                                this.entries = dropDownMenuEntriesProdukte.entries
                                this.clickedEntryDropDownProp = clickedEntry
                                this.onClickedEntryDropDownPropChange = { value -> setClickedEntry(value) }

                                this.titleStyleClass = dropDownMenuEntriesProdukte.titleStyle
                                this.entryBlockStyleClass = dropDownMenuEntriesProdukte.entryBlockStyle
                                this.eachEntryStyleClass = dropDownMenuEntriesProdukte.eachEntryStyle
                            }
                        }
                    }
                    styledTd {
                        css {
                            +BaseLayoutStyles.alignContentAtEnd
                            +BaseLayoutStyles.alignTextRight
                            +BaseLayoutStyles.width6em
//                            +BaseLayoutStyles.solidBorder1px
                        }
                        dropDownMenu{
                            attrs {
                                this.title = dropDownMenuEntriesUnternehmen.title
                                this.entries = dropDownMenuEntriesUnternehmen.entries
                                this.clickedEntryDropDownProp = clickedEntry
                                this.onClickedEntryDropDownPropChange = { value -> setClickedEntry(value) }
                                this.titleStyleClass = dropDownMenuEntriesProdukte.titleStyle
                                this.entryBlockStyleClass = dropDownMenuEntriesProdukte.entryBlockStyle
                                this.eachEntryStyleClass = dropDownMenuEntriesProdukte.eachEntryStyle
                            }
                        }
                    }
                    styledTd {
                        css {
                            +BaseLayoutStyles.width10em
                            +BaseLayoutStyles.noMarginNoPaddingNoBorders
                            +BaseLayoutStyles.alignTextCenter
                            +BaseLayoutStyles.alignContentAtEnd
//                            +BaseLayoutStyles.solidBorder1px
                        }
                        navigationElement {
                            attrs.title = "über diese Seite"
                            attrs.onClickedEntryNavigationChange = { value -> setClickedEntry(value) }
                            attrs.titleStyle = navigationElementStyleClass
                        }
                    }
                }
            }
        }

        styledTable {
            attrs.id = "articleTable"
            css {
                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                +BaseLayoutStyles.baseBackgroundColor
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.stdtTableLayout
                +BaseLayoutStyles.alignContentAtEnd
                +BaseLayoutStyles.overflowHidden
                +BaseLayoutStyles.standardFont
                +BaseLayoutStyles.articleHeight
//                +BaseLayoutStyles.dottedBorder1px
            }
            styledTbody {
                attrs.id = "articleTableBody"
                css {
                    +BaseLayoutStyles.articleHeight
                    +BaseLayoutStyles.noMarginNoPaddingNoBorders
//                    +BaseLayoutStyles.solidBorder1px
                }
                styledTr {
                    attrs.id = "articleRow"
                    css {
                        +BaseLayoutStyles.articleHeight
                        +BaseLayoutStyles.fullWidth
                        +BaseLayoutStyles.noMarginNoPaddingNoBorders
//                    +BaseLayoutStyles.solidBorder1px
                        +BaseLayoutStyles.alignSelfStart
                        +BaseLayoutStyles.alignContentAtStart
                        +BaseLayoutStyles.top0px
                        +BaseLayoutStyles.alignItemsStart
                        +BaseLayoutStyles.alignSelfStart
                    }
                    styledTd {
                        css {
                            +BaseLayoutStyles.articleHeight
                            +BaseLayoutStyles.noMarginNoPaddingNoBorders
//                        +BaseLayoutStyles.dottedBorder1px
                            +BaseLayoutStyles.alignItemsStart
                            +BaseLayoutStyles.alignContentAtStart
                            +BaseLayoutStyles.alignSelfStart
                        }
                        styledArticle {
                            attrs.id = "article"
                            css {
                                +BaseLayoutStyles.articleHeight
                                +BaseLayoutStyles.paddingMarginVerticalZero
                                +BaseLayoutStyles.marginHorizontal2em
                                +BaseLayoutStyles.paddingHorizontal1em

                                +BaseLayoutStyles.alignContentAtStart
                                +BaseLayoutStyles.alignSelfStretch
                                +BaseLayoutStyles.alignTextCenter
                                +BaseLayoutStyles.article
                                +BaseLayoutStyles.overflowAuto
//                                +BaseLayoutStyles.solidBorder1px
                            }

                            styledDiv {
                                attrs.id = "articleDiv"
                                css {
                                    +BaseLayoutStyles.noMarginNoPaddingNoBorders
                                    +BaseLayoutStyles.alignSelfStretch
                                    +BaseLayoutStyles.fullWidth
                                    +BaseLayoutStyles.articleHeight
//                                +BaseLayoutStyles.dottedBorder1px
                                }
                                setArticleContent{
                                    attrs.clickedEntry = clickedEntry
                                }
                            }
                        }
                    }
                }
            }
        }
        styledTable {
            attrs.id = "footerTable"
            css {
                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                +BaseLayoutStyles.baseBackgroundColor
                +BaseLayoutStyles.fullWidth
                +BaseLayoutStyles.stdtTableLayout
                +BaseLayoutStyles.alignContentAtEnd
                +BaseLayoutStyles.overflowHidden
                +BaseLayoutStyles.standardFont
                +BaseLayoutStyles.footerHeight
                +BaseLayoutStyles.bottom0px
            }
            styledTbody {
                attrs.id = "footerTableBody"
                css {
                    +BaseLayoutStyles.fullWidth
                    +BaseLayoutStyles.footerHeight
                    +BaseLayoutStyles.noMarginNoPaddingNoBorders
                    +BaseLayoutStyles.standardFont
                    +BaseLayoutStyles.bottom0px
                }
                styledTr {
                    attrs.id = "footerRow"
                    css {
                        +BaseLayoutStyles.footerHeight
                        +BaseLayoutStyles.fullWidth
//                        +BaseLayoutStyles.paddingMarginZero
                        +BaseLayoutStyles.bottom0px
                        +BaseLayoutStyles.noMarginNoPaddingNoBorders
                        +BaseLayoutStyles.alignContentAtCenter
//                        +BaseLayoutStyles.solidBorder5px
                    }
                    styledTd {
                        css {
                            +BaseLayoutStyles.fullWidth
//                            +BaseLayoutStyles.paddingMarginZero
                            +BaseLayoutStyles.noMarginNoPaddingNoBorders
                            +BaseLayoutStyles.footerHeight
                            +BaseLayoutStyles.footer
                            +BaseLayoutStyles.bottom0px
//                            +BaseLayoutStyles.solidBorder5px
                        }
                        styledFooter {
                            css {
                                BaseLayoutStyles.fullWidth
                                +BaseLayoutStyles.footerHeight
                                +BaseLayoutStyles.alignTextCenter
                                +BaseLayoutStyles.noMarginNoPaddingNoBorders
                                +BaseLayoutStyles.bottom0px
                            }
                            +"Copyright \u00A9 ${companyName.fullNameString()} 2025"
                        }
                    }
                }
            }
        }
    }


    val setArticleContent = fc<SetArticleProps>("SetArticleContent") { props ->
        when (props.clickedEntry) {
            "" -> {
                return@fc welcomeContent()
            }
            "Software Entwicklung" -> {
                return@fc softwareDevelopmentContent()
            }
            "Optimierung des Entwicklungsprozesses" -> {
                return@fc optimizingOfDevelopmentProcessContent()
            }
//            "Kontakt" -> {
//                return contactContent {
//
//                }
//            }
           "Impressum" -> {
               return@fc imprintContent()
            }
            "über diese Seite" -> {
                return@fc aboutThisPageContent()
            }

            else -> {
                return@fc welcomeContent()
            }
        }
    }


    val createdTable = fc<Props>("NusquamHomepage") {
        baseLayoutTable()
    }

}

